/**
 * {@docCategory HoverCard}
 */
export var ExpandingCardMode;

(function (ExpandingCardMode) {
  /**
   * To have top compact card only
   */
  ExpandingCardMode[ExpandingCardMode["compact"] = 0] = "compact";
  /**
   * To have both top compact and bottom expanded card
   */

  ExpandingCardMode[ExpandingCardMode["expanded"] = 1] = "expanded";
})(ExpandingCardMode || (ExpandingCardMode = {}));